import { render } from "./UnifiedHeader.vue?vue&type=template&id=260e2b41"
import script from "./UnifiedHeader.vue?vue&type=script&lang=js"
export * from "./UnifiedHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__